import { fetchAccessTokenIfNeeded } from '~/AccessToken';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import { updateUserProductGroupNotificationSettings } from '~/Api/User/ProductGroup/NotificationSettings';
import { invokeApi } from '~/ApiClient';
import { ActionTypes } from '~/ProductGroup';
import { ThunkAction } from '~/Store';

export function update(group: UserProductGroup, frequency: string): ThunkAction<Promise<void>, any> {
	return async (dispatch) => {
		const userId = (await dispatch(fetchAccessTokenIfNeeded())).accessToken.user.id;
		const request = dispatch(invokeApi(updateUserProductGroupNotificationSettings, userId, group.id, frequency));
		dispatch({ type: ActionTypes.requestUpdate, request, id: group.id });

		try {
			const { notificationSettings } = await request;
			dispatch({
				type: ActionTypes.receiveUpdate,
				request,
				id: group.id,
				group: group.notificationSettingsUpdated(notificationSettings),
			});
		} catch (error) {
			dispatch({
				type: ActionTypes.receiveUpdate,
				request,
				id: group.id,
				group: null,
			});
			throw error;
		}
	};
}
